<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-01 11:52:56
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:55:45
 * @Description: file content
活动模版
 -->
<template>
  <div class="LayoutAct" style="padding-bottom:50px;">
    <router-view></router-view>
    <Tabbar9></Tabbar9>
  </div>
</template>

<script>
import util from "@/utils/utils";
import Cookies from "js-cookie";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
const Tabbar9 = () => import("@/components/tabbar9");
export default {
  components: {
    Tabbar9
  },
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo",
      "sourceGzhInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO",
      SET_PAGEINFO: "SET_PAGEINFO",
      SET_SOURCEGZHINFO: "SET_SOURCEGZHINFO"
    })
  },
  beforeCreate() {},
  created() {
    const that = this;
    if (
      util.queryCheck(
        {
          id: "PageId",
          psn: "防刷参数"
        },
        that.$route.query
      )
    ) {
      // 获取页面信息
      comreq
        .getPageInfo(that.$route.query.id, that.$route.query.psn, that)
        .then(function(pageInfo) {
          that.SET_PAGEINFO(pageInfo);
          // if (that.$route.query.isnew && that.$route.query.isnew == 1) {
          //   that.isShowCreateAfterGuide = true;
          // }
        });
      let tmpTxt = "AI";
      if (
        location.host.indexOf(".rushiai.") > -1 ||
        location.host.indexOf(".huafamarkting.") > -1
      ) {
        tmpTxt = "";
      }
      // 设置内容自行动
      util
        .checkMapStateCallback(that, ["pageInfo", "shareSpreadInfo"])
        .then(() => {
          // 微信网页
          // 需要设置分享
          if (that.$route.query.entry == "zxslzx") {
            // 在线售楼中心，遇到销售或者职业经纪人带上rscuid传播。在楼盘详情如果有rscuid，销售员列表就只展示这个人。
            comreq.getUserIntegralInfo().then(userInfo => {
              if (
                userInfo.isSale == true ||
                (userInfo.isAgent == true &&
                  userInfo.agentInfo &&
                  userInfo.agentInfo.authtype == 2)
              ) {
                let shareSpreadInfo = that.shareSpreadInfo;
                shareSpreadInfo.rscuid = that.$openid;
                this.SET_SHARESPREADINFO(shareSpreadInfo);
              }
              util.setFoundShare2(
                // `${that.pageInfo.Extinfo.buildingName}${tmpTxt}售楼中心，线上看房，实时咨询，欢迎您的光临！`,
                // "美好人居，一触即达。帮忙传播，更有多重惊喜呦！",
                // that.pageInfo,
                // that.shareSpreadInfo,
                // false,
                // `&entry=zxslzx&ctype=${that.$route.query.ctype}`
                "还再等什么？赶快点进来，超多惊喜等你拿！",
                "还再等什么？赶快点进来，超多惊喜等你拿！",
                that.pageInfo,
                that.shareSpreadInfo,
                false,
                `&entry=zxslzx&orgfrom=${that.$route.query.orgfrom}&ctype=${
                  that.$route.query.ctype
                }&t9id=${
                  that.$route.query.t9id ? that.$route.query.t9id : ""
                }&t9psn=${
                  that.$route.query.t9psn ? that.$route.query.t9psn : ""
                }`,
                "https://assets.rurushishi.com/yq-rs-make/components/act/share.png"
              );
            });
          } else {
            util.setFoundShare(that.pageInfo, that.shareSpreadInfo);
          }
          that.global.SHARE_CALLBACK_OK = function() {
            comreq.actShare(that);
            // 很多宝先隐藏了分享后页面
            // that.showShareAfterAction();
          };

          // comreq
          //   .getChannelInfoByPageId(that.pageInfo.PageId)
          //   .then(function(sourceGzhInfo) {
          //     that.SET_SOURCEGZHINFO(sourceGzhInfo);
          //   });
          // that.setSelfAction();
          // that.setSendTime();
          // // 上报设备信息
          // comreq.actMt(that);
        });
    }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
</style>